import { useContext, useEffect, useState } from "react";
import { ContainerOrdenes } from "./localStyle";
import FrenteOrden from "../FrenteOrden/FrenteOrden";
import AutorizacionOrden from "../AutorizacionOrden/AutorizacionOrden";
import FirmaOrden from "../FirmaOrden/FirmaOrden";
import {
  wsPostOrdenConFirmaDigital,
  wsPostSubirOrden,
} from "_+_Portal/context/Actions/ordenEstudio/ordenEstudio";
import { PortalContext } from "_+_Portal/context/Provider";
import { showToaster } from "global/context/action/toaster/toaster";
import { GlobalContext } from "global/context/Provider";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";

const SubirOrdenComponent = ({ turno, callback, enviarPuntoControl }) => {
  const [step, setStep] = useState("subirFrenteOrden");
  const [listMedia, setListMedia] = useState([]);
  const [flgPost, setFlgPost] = useState(false);
  const { ordenEstudioDispatch } = useContext(PortalContext);
  const { toasterDispatch } = useContext(GlobalContext);

  const requiereAutorizacion = turno.requiereAutorizacion;
  const sinFirmaPacOrdenTurno = turno.sinFirmaPacOrdenTurno;
  const sinFirmaPacOrdenLabo = turno.sinFirmaPacOrdenLabo;

  const addMedia = (newMedia) => {
    setListMedia((prevList) => [...prevList, newMedia]);
  };

  const nextStepSubirOrden = (isCorrect) => {
    if (isCorrect) {
      showToaster(
        {
          texto: "Se ha subido la orden correctamente.",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
      callback();
    } else {
      showToaster(
        {
          texto: "No se ha subido la orden correctamente.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
      enviarPuntoControl();
    }
  };

  const finalizarProceso = (dto, type) => {
    let sinFirmaPaciente = null;
    if (turno.idProtocolo <= 0) {
      sinFirmaPaciente = sinFirmaPacOrdenTurno;
    } else {
      sinFirmaPaciente = sinFirmaPacOrdenLabo;
    }
    if (type === "frenteOrden") {
      setListMedia(dto);
      if (requiereAutorizacion) {
        setStep("autorizacionOrden");
      } else {
        if (!sinFirmaPaciente) {
          setStep("firmaOrden");
        } else {
          setFlgPost(true);
          setStep("");
        }
      }
    }
    if (type === "autorizacionOrden") {
      addMedia(dto);
      if (!sinFirmaPaciente) {
        setStep("firmaOrden");
      } else {
        setFlgPost(true);

        setStep("");
      }
    }
    if (type === "firmaOrden") {
      const dtoOrden = {
        firmaDigitalDto: { id: turno.idturno, descripcion: dto.binario },
        listMediaDto: listMedia,
      };
      wsPostOrdenConFirmaDigital(
        dtoOrden,
        nextStepSubirOrden
      )(ordenEstudioDispatch);
      setStep("");
    }
  };

  useEffect(() => {
    if (flgPost && listMedia.length > 0) {
      wsPostSubirOrden(listMedia, nextStepSubirOrden)(ordenEstudioDispatch);
      setFlgPost(false);
    }
  }, [flgPost, listMedia]);

  const renderStep = () => {
    switch (step) {
      case "subirFrenteOrden":
        return (
          <FrenteOrden
            finalizarProceso={finalizarProceso}
            idTurno={turno?.idturno ? turno?.idturno : turno.idProtocolo}
          />
        );
      case "autorizacionOrden":
        return (
          <AutorizacionOrden
            finalizarProceso={finalizarProceso}
            idTurno={turno?.idturno ? turno?.idturno : turno.idProtocolo}
          />
        );
      case "firmaOrden":
        return (
          <FirmaOrden
            finalizarProceso={finalizarProceso}
            idTurno={turno?.idturno ? turno?.idturno : turno.idProtocolo}
          />
        );
      default:
        return (
          <Loading
            dataLoading={true}
            descripcion="Cargando..."
            color={"c-white"}
          />
        );
    }
  };

  return <ContainerOrdenes>{renderStep()}</ContainerOrdenes>;
};

export default SubirOrdenComponent;
